/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateSnippetCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['key', codecString],
    ['value', codecString],
]);
export class CreateSnippetCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateSnippetCourseDataParser.decode(input).map(res => new CreateSnippetCourseData(res));
    }
    static unsafeDecode(input) {
        return CreateSnippetCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateSnippetCourseDataParser.encode(data);
    }
    static schema() {
        return CreateSnippetCourseDataParser.schema();
    }
}
